import { FaPercent } from "react-icons/fa"
import { DetailPage, Row } from "../../components/crud/DetailPage"
import { FkLink, ListPage } from "../../components/crud/ListPage"
import { AsyncSelect, DateInput, ImageInput, MoneyInput, NumberInput, Select, TextareaInput, TextInput } from "../../components/forms/Inputs"
import { useOptions } from "../../hooks/useOptions"
import { useTranslations } from "../../layers/Localization"
import { HistoriquesList } from "./Historique"
import { roundCurrency } from "../../hooks/helpers"
import { MaterielList } from "./Materiel"
import { useToday } from "../../hooks/useToday"

export const useCodesTvaOptions = () => {
    return [
        { value: 'ZERO', label: '0%', taux: 0 },
        { value: 'SIX', label: '6%', taux: 6 },
        { value: 'VINGT_ET_UN', label: '21%', taux: 21 },
        { value: 'VINGT_BIS', label: '20 Bis', taux: 0 },
    ]
}

function ArticleFields({ item, set, tab }) {
    const t = useTranslations()
    const fournisseursOptions = useOptions('fournisseurs', 'nom')
    const codeTvaOptions = useCodesTvaOptions()
    const today = useToday()

    const changePrixPublique = value => {
        set('prixPublique')(value)
        set('majPrixPublique')(today)
        if (![null, undefined].includes(value) && ![null, undefined].includes(item.ristourne)) changePrixAchat(roundCurrency(value * (1 - item.ristourne / 100)))
    }
    const changeRistourne = value => {
        set('ristourne')(value)
        set('majPrixPublique')(today)
        if (![null, undefined].includes(value) && ![null, undefined].includes(item.prixPublique)) changePrixAchat(roundCurrency(item.prixPublique * (1 - value / 100)))
    }
    const changePrixAchat = value => {
        set('prixAchat')(value)
        set('majPrixAchat')(today)
        if (![null, undefined].includes(value) && ![null, undefined].includes(item.marge)) changePrixVente(roundCurrency(value * (1 + item.marge / 100)))
    }
    const changeMarge = value => {
        set('marge')(value)
        set('majPrixAchat')(today)
        if (![null, undefined].includes(value) && ![null, undefined].includes(item.prixAchat)) changePrixVente(roundCurrency(item.prixAchat * (1 + value / 100)))
    }
    const changePrixVente = value => {
        set('prixVente')(value)
        set('majPrixVente')(today)
    }

    return <>
        <Row start>
            <ImageInput label={t("Photo")} value={item.photo} onChange={set('photo')} />
            <div className="grow flex flex-col gap-5">
                <Row>
                    <TextInput className="grow" label={t("Nom")} value={item.nom} onChange={set('nom')} required />
                    <AsyncSelect label={t("Fournisseur")} value={item.fournisseurId} onChange={set('fournisseurId')} options={fournisseursOptions} />
                </Row>
                <Row>
                    <Select label={t("Régime TVA")} value={item.codeTva} onChange={set('codeTva')} options={codeTvaOptions} />
                    <TextInput className="grow" label={t("Reference fournisseur")} value={item.referenceFournisseur} onChange={set('referenceFournisseur')} />
                    <TextInput className="grow" label={t("Emballage")} value={item.embalage} onChange={set('embalage')} />
                </Row>
                <Row>
                    <NumberInput className="grow" label={t("Quantité du dernier relevé de stock")} value={item.quantiteInventaire} onChange={set('quantiteInventaire')} />
                    <DateInput label={t("Date du dernier relevé de stock")} value={item.dateInventaire} onChange={set('dateInventaire')} />
                </Row>
            </div>
        </Row>
        <hr />
        <div className="flex flex-col gap-5 md:grid md:grid-cols-[1fr_1fr_auto] flex-wrap">
            <MoneyInput label={t("Prix publique")} value={item.prixPublique} onChange={changePrixPublique} />
            <NumberInput label={t("Ristourne")} value={item.ristourne} onChange={changeRistourne} icon={<FaPercent />} />
            <DateInput label={t("Mise à jour du prix publique")} value={item.majPrixPublique} onChange={set('majPrixPublique')} />
            <MoneyInput label={t("Prix d'achat")} value={item.prixAchat} onChange={changePrixAchat} required />
            <NumberInput label={t("Marge")} value={item.marge} onChange={changeMarge} icon={<FaPercent />} />
            <DateInput label={t("Mise à jour du prix d'achat")} value={item.majPrixAchat} onChange={set('majPrixAchat')} />
            <MoneyInput label={t("Prix de vente")} value={item.prixVente} onChange={changePrixVente} required />
            <div></div>
            <DateInput label={t("Mise à jour du prix de vente")} value={item.majPrixVente} onChange={set('majPrixVente')} />
        </div>
        <hr />
        <TextareaInput className="[&_textarea]:text-red-600" label={t("Mémo interne")} value={item.memoInterne} onChange={set('memoInterne')} />
    </>

}

export function ArticlesList(props) {
    const t = useTranslations()
    return <ListPage model="articles" title={t("Articles")} columns={{
        [t('Nom')]: 'nom',
        [t('Fournisseur')]: { sort: 'fournisseur', value: item => <FkLink>{item.fournisseur?.nom}</FkLink> },
        [t('Quantité')]: 'quantiteInventaire',
    }} join={{
        fournisseur: 'nom'
    }} {...props} />
}

export function ArticleDetail(props) {
    const t = useTranslations()
    return <DetailPage model="articles" title={t("Article")} Fields={ArticleFields} tables={{
        [t('Historique')]: <HistoriquesList relation="articleId" root="." />,
        [t("Chantiers")]: <MaterielList relation="articleId" />,
    }} {...props} />
}
